module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAYAAADimHc4AAABYklEQVR4Ae3bEUyucRjG4T8cPBAezHcwCHPJF+TLF+SUL6cgDPIFYb4wDIIg+ODrkUcKWru3ntqua3scfvLuft93AQAAAAAAAAAAfNV2uz2v+7N+qO0nfn+AUu7r/q8RArTXupM1RoB2XfdvjRCgPdUdrjECtIu6v2uEAO2hbm+NEKBt6k4HHlcFeOe2bleAmQDtue5IgLkA7bJuZ+UECDzWHaycAIFNvicJkMv3JAFyvSflBMjc5HuSAKl8TxIgkO9JAuTyPUmAltvUnX14XBUgF+5JAgx46T1JgFlXdTsCzOo9SYAhL3XHAsy4q9tdTYCZR1IBvtdD3f76nADzs4QAU8OcAAPTtADjL2cEmH89KUAuf0EvwPQnKgLko1pOgHxWzgkw9aGuAPmOkxNg/GcNAYZ/VxKgd5wBAgQ7TkaA3nEGCNA7zgABgh0nIEDvOAME6B1ngAAAAAAAAAAAAMCANxuXOroR8Bv1AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/skip-white-icon.png
// module id = 387
// module chunks = 0